const initialState = {
  stpProds: [],
  seller_id: null,
  company_esi_id: null,
  supplier_id: null,
  noDownwardChain: false,
  selectedStp: {},
  isDeliveryAddressSameAsConsigneeAddress: true,
};

const bcmOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_BCM_ORDER': {
      return {
        ...initialState,
        stpProds: [],
      };
    }
    case 'SET_SELLER_ID': {
      return { ...state, seller_id: action.data };
    }
    case 'SET_COMPANY_ESI_ID': {
      return { ...state, company_esi_id: action.data };
    }
    case 'SET_SUPPLIER_ID': {
      return { ...state, supplier_id: action.data };
    }
    case 'SET_NO_DOWNWARD_CHAIN': {
      return { ...state, noDownwardChain: action.data };
    }
    case 'SET_SELECTED_STP': {
      return { ...state, selectedStp: action.data };
    }
    case 'SET_DELIVERY_ADDRESS_SAME_AS_CONSIGNEE_ADDRESS': {
      return { ...state, isDeliveryAddressSameAsConsigneeAddress: action.data };
    }
    default:
      return state;
  }
};

export default bcmOrderReducer;
